import React from "react";
import heroImg from "../../assets/policies/heroImg.webp";

const Disclaimer = () => {
  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-once="true"
      className="relative pt-24 md:pt-32 lg:pt-28 pb-4 md:pb-4 lg:pb-8 
                        px-4 md:px-8 lg:px-12 
                        bg-[#070021] text-white 
                        font-poppins tracking-widest"
    >
      {/* Left Blur  */}
      <div
        className="absolute left-0 top-0 w-[40%] h-[40%] rounded-full 
                           bg-[#1a99c03b] blur-[100px] md:blur-[140px] lg:blur-[180px] 
                           z-0"
      ></div>

      {/* Right Blur */}
      <div
        className="absolute right-0 top-0 w-[45%] h-[45%] rounded-full 
                           bg-[#1a99c03b] blur-[120px] md:blur-[160px] lg:blur-[200px] 
                           z-0"
      ></div>
      <div className="absolute top-0 -right-12 w-[40%]">
        <img
          src={heroImg}
          alt="Hero Background"
          className="inset-0 w-[100%] h-full object-cover "
          loading="eager"
          fetchpriority="high"
        />
      </div>

      <div className="max-w-[95%] mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-3xl font-semibold mb-4">
          Disclaimer
        </h1>
        <div
          className="h-[0.8px] w-full mb-8 
                        bg-gradient-to-r from-[#49D093] via-[#38b87eef] to-[#0C226E]"
        />
        {/* General Information */}
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                        font-extralight ml-2 mb-6 leading-relaxed"
          >
            <span className="text-[#49D093]">© 2025 Mark9 Pte Ltd.</span> All
            rights reserved. <br />
            The information on this website and in related Mark9 materials is
            provided for general informational purposes only and does not
            constitute professional advice, commitment, or warranty of any kind.{" "}
            <br />
            While every effort has been made to ensure accuracy, Mark9 Pte. Ltd.
            makes no representations or guarantees about completeness,
            timeliness, or suitability of the information, products, or services
            described.
          </p>

          <p
            className="text-[10px] md:text-[12px] lg:text-[12px] 
                        font-extralight ml-2 mb-4 leading-relaxed"
          >
            <span className="text-[#49D093]">Mark9 Pte. Ltd.</span> shall not be
            liable for any direct, indirect, or consequential loss arising from
            reliance on this content or linked third-party resources. <br />
            All trademarks and product names mentioned are the property of their
            respective owners. <br />
            Use of this site implies acceptance of our Terms & Conditions and
            Privacy Policy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
